import { DSButton, DSCol, DSModal, DSRow, DSText } from '@vr/ds-react'

const ModalConfirmationRemoveCollaborator = ({
  onClose = () => {},
  handleRemove = () => {},
  collaborator
}: {
  onClose?: () => void
  handleRemove?: () => void
  collaborator: any
}) => {
  return (
    <DSModal config={{ show: true, onClose }}>
      <DSModal.Header onClose={onClose}>Confirmação</DSModal.Header>
      <DSModal.Body
        css={{ textAlign: 'center', alignItems: 'center', gap: '$sm24' }}
      >
        <DSText as='p'>Deseja remover este colaborador da lista?</DSText>
        <DSText as='p' weight='bold'>
          {collaborator?.colaborador}
        </DSText>
      </DSModal.Body>
      <DSModal.Footer>
        <DSRow wrap='wrap' align='center'>
          <DSCol
            xs={12}
            lg={12}
            gap={4}
            style={{ display: 'flex' }}
            justify='center'
          >
            <DSButton variant='ghost' onClick={onClose} outlined>
              Cancelar
            </DSButton>
            <DSButton
              onClick={() => {
                handleRemove()
                onClose()
              }}
            >
              Confirmar
            </DSButton>
          </DSCol>
        </DSRow>
      </DSModal.Footer>
    </DSModal>
  )
}

export default ModalConfirmationRemoveCollaborator
